import { TextureLoader, LinearSRGBColorSpace, SRGBColorSpace } from "three";
import { debug, warn } from "./logger";

//TODO: support KTX2 textures!

const getMaterialMapUpdater = (propName) =>
	async (mesh, textureUrl, onLoad) => {
		mesh._d8sReplaceCalled = mesh._d8sReplaceCalled ? mesh._d8sReplaceCalled + 1 : 1;

		const material = mesh.material;

		try {
			if (textureUrl === false) {
				debug(`[d8s renderer]: removing texture on mesh (${mesh.name}) material (${mesh.material.name}) count: ${mesh._d8sReplaceCalled}`)
				material[propName] = null;
			} else {
				debug(`[d8s renderer]: replacing texture on mesh (${mesh.name}) material (${mesh.material.name}) count: ${mesh._d8sReplaceCalled}`)
				let texture = await new TextureLoader().loadAsync(textureUrl);
				//allow consumer to update the texture before its being used (ex: change aspect ratio)
				texture = onLoad ? (onLoad(mesh, material, texture) || texture) : texture;

				texture.colorSpace = propName === "normalMap" ? LinearSRGBColorSpace : SRGBColorSpace;

				material[propName] = texture;
				material.needsUpdate = true;
			}
		} catch (ex) {
			warn(`[d8s renderer]: Failed to replace texture(${propName}) from url: ${textureUrl} on material`);
			console.error(ex);
		}
	};

export const setMeshMaterialTexture = getMaterialMapUpdater("map");

export const setMeshMaterialRoughness = getMaterialMapUpdater("roughnessMap");

export const setMeshMaterialNormal = getMaterialMapUpdater("normalMap");

export const setMeshMaterialAlpha = getMaterialMapUpdater("alphaMap");

export const setMeshMaterialAo = getMaterialMapUpdater("aoMap");

export const setMeshMaterialMetalness = getMaterialMapUpdater("metalnessMap")

export const setMeshMaterialBump = getMaterialMapUpdater("bumpMap");
